/* JWT claim anahtarları */
const CLAIMS = {
    email: 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress',
    name: 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name',
    nameId: 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier',
    role: 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role',
}

export function parseJwt(token) {
    const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')
    const binary = atob(base64)
    const bytes = Uint8Array.from(binary, c => c.charCodeAt(0))
    const json = JSON.parse(new TextDecoder('utf-8').decode(bytes))

    let branchId = ''
    let branchAssignments = []
    try {
        const meta = JSON.parse(json.MetaData ?? '{}')
        branchId = meta.BranchId ?? ''
        branchAssignments = (meta.BranchAssignments ?? '').split(';').filter(Boolean)
    } catch { }

    let organizations = {}
    try { organizations = JSON.parse(json.Organizations ?? '{}') } catch { }

    return {
        userId: json[CLAIMS.nameId] ?? '',
        username: json.Username ?? '',
        fullName: json[CLAIMS.name] ?? '',
        email: json[CLAIMS.email] ?? '',
        sessionId: json.SessionId ?? '',
        isEmailConfirmed: json.IsEmailConfirmed === 'True',
        roles: (json[CLAIMS.role] ?? '').split(';').filter(Boolean),
        permissions: (json.Permissions ?? '').split(';').filter(Boolean),
        branchId,
        branchAssignments,
        organizations,
        os: json.Os ?? '',
        device: json.Device ?? '',
        browser: json.Browser ?? '',
        ipAddress: json.IpAddress ?? '',
        exp: json.exp ?? 0,
    }
}

export function isTokenExpired(exp) {
    return Date.now() / 1000 > exp
}